import { Component } from 'react';
import './LanguageDetector.scss';

class LanguageDetector extends Component {
	constructor(props) {
		super(props);
		this.state = {
			message: '',
		}

		this.handleButtonClick = this.handleButtonClick.bind(this);
	}

	handleButtonClick(event) {
		event.preventDefault();
		this.detectLanguage();
	}

	render() {
		let info = this.state.languageName || this.state.message;
		return (
			<span className="language-detector">
				<button className="button secondary" onClick={this.handleButtonClick}>Detect language</button>
				<span className="info">{info}</span>
			</span>
		)
	}

	detectLanguage() {
		const {langDetection, isLimitUsed, url} = this.props;
		if (!langDetection) {
			alert('This feature is available in paid plans');
			return;
		}
		if (isLimitUsed) {
			alert('You have reached the usage limit. Subscribe to a higher plan for higher or no limits');
			return;
		}
		if (!url) {
			this.setState({
				message: 'No URL provided',
			});
			return;
		}

		this.setState({
			message: 'Detecting language...',
		});

		const data = new FormData();
		data.append('url', url);

		fetch('ajax/detect-language.php', {
			method: 'POST',
			cache: 'no-cache',
			body: data
		})
		.then(response => response.json())
		.then(respData => {
			this.props.updateLimitUsage('snippet-preview');
			if (respData.status === 'ok') {
				let detectedLanguage = respData.lang.trim();
				this.props.callback(detectedLanguage);
				this.setState({
					message: detectedLanguage,
				});
			} else {
				this.setState({
					message: respData.message,
				})
			}
		})
		.catch(error => {
			console.error(error);
			this.setState({
				message: error.toString()
			})
		});
	}
}

export default LanguageDetector;